import { render, staticRenderFns } from "./WeiboTree.vue?vue&type=template&id=08fa2f49&"
import script from "./WeiboTree.vue?vue&type=script&lang=js&"
export * from "./WeiboTree.vue?vue&type=script&lang=js&"
import style0 from "./WeiboTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports